const encodeBase64 = (value: string): string => {
  const bytes = new TextEncoder().encode(value);
  const binary = Array.from(bytes, (byte) => String.fromCodePoint(byte)).join(
    '',
  );

  return btoa(binary);
};

const decodeBase64 = (value: string): string => {
  const bytes = Uint8Array.from(
    atob(value),
    (char) => char.codePointAt(0) as number,
  );

  return new TextDecoder().decode(bytes);
};

export { decodeBase64, encodeBase64 };
